export const QUERY_PARAMS = {
  KEYWORD: 'keyword',
  TAB: 'tab',
  YEAR: 'year',
  SCOPE_TYPE: 'scopeType',
  BRANCH_ID: 'branchId',
  BRANCH_NAME: 'branchName',
  BRANCH_IDS: 'branchIds',
  BRANCH_NAMES: 'branchNames',
  COMPANY_ID: 'companyId',
  COMPANY_NAME: 'companyName',
  YEAR_MONTH_USE_FROM: 'yearMonthUseFrom',
  YEAR_MONTH_USE_TO: 'yearMonthUseTo',
  EMISSION_AMOUNT_FROM: 'emissionAmountFrom',
  EMISSION_AMOUNT_TO: 'emissionAmountTo',
  SCOPE_VALUE: 'scopeValue',
  SCOPE_ID: 'scopeId',
  SCOPE_LABEL: 'scopeLabel',
  SCOPE_TYPE_INDEX: 'scopeTypeIndex',
  CATEGORY_ID: 'categoryId',
  CONDITION_ID: 'conditionId',
  FILTER_NAME: 'filterName',
  IS_SEARCH: 'isSearch',
  SEARCH_QUERY: 'searchQuery',
  REDUCTION_STRATEGY_ITEM_ID: 'reductionStrategyItemId',
  REDUCTION_STRATEGY_ITEM_NAME: 'reductionStrategyItemName',
  DEMO: 'demo',
  TEXT_SEARCH: 'textSearch',
  STATUS_SELECTED: 'statusSelected',
  TOKEN: 'token',
  TYPE: 'type',
  STATUS: 'status',
  EMISSION_NAME: 'emissionName',
  ITEM_NAME: 'itemName',
  CATEGORY_NAME: 'categoryName',
  ACTION: 'action',
  HIDDEN_COLUMNS_TAB_1: 'hiddenColumnTab1',
  HIDDEN_COLUMNS_TAB_2: 'hiddenColumnTab2',
  HIDDEN_COLUMNS_TAB_3: 'hiddenColumnTab3',
  CATEGORYID: 'categoryId',
  IS_COMPANY: 'isCompany',
  IS_USE: 'isUse',
  UPLOAD_ID: 'uploadId',
  NAME: 'name',
  DATE: 'date',
  GROUP_ID: 'groupId',
  GROUP_NAME: 'groupName',
  DATE_FROM: 'dateFrom',
  DATE_TO: 'dateTo',
  SEARCH_TYPE: 'searchType',
}
